export class Storage
{
    // Note: This needs to be a flat data structure
    static DEFAULT_DATA = {
        "sessionToken" : null,
        "isKnown" : false,
        "isSoi" : false
    };

    constructor( appInstance)
    {
        this.app = appInstance;
        this.checkSoi();
    }

    saveSessionToken( sessionToken )
    {
        this.save( "sessionToken", sessionToken );
        if ( this.app.isNativeMobile() && window.parent )
        {
            try
            {
                window.parent.postMessage( { 'sessiontoken' : sessionToken }, "*" );
            }
            catch ( err )
            {
                // Fail silently
            }
        }
    }

    loadSessionToken()
    {
        let st = this.load( "sessionToken" );
        if ( !st || st.length < 3 )
        {
            // Try to resolve from url
            const searchParams = new URL( document.location.toString() ).searchParams;
            const urlSt = searchParams.get( 'st' );
            if ( urlSt && urlSt.length > 3 )
            {
                st = urlSt;
            }
        }

        return st;
    }

    deleteSessionToken()
    {
        this.save( "sessionToken", null );
        if ( this.app.isNativeMobile() && window.parent )
        {
            try
            {
                window.parent.postMessage( { 'sessiontoken' : '' }, "*" );
            }
            catch ( err )
            {
                // Fail silently
            }
        }
    }

    loadIsKnown()
    {
        return this.load( 'isKnown', false );
    }

    checkSoi()
    {
        // Try to resolve from url
        const searchParams = new URL( document.location.toString() ).searchParams;
        const from = searchParams.get( 'from' );
        if ( from && from === "soi" )
        {
            this.saveIsSoi( true );
        }
    }

    saveIsKnown( isKnown )
    {
        this.save( 'isKnown', isKnown );
    }

    loadIsSoi()
    {
        return this.load( 'isSoi', false );
    }

    saveIsSoi( isSoi )
    {
        this.save( 'isSoi', isSoi );
    }

    load( key, defVal = null )
    {
        const sd = this.loadStorageData();
        if ( sd.hasOwnProperty( key ) )
        {
            return sd[ key ];
        }
        else
        {
            return defVal;
        }
    }

    save( key, val )
    {
        const sd = this.loadStorageData();
        sd[ key ] = val;
        this.saveStorageData( sd );
    }

    saveStorageData( updatedSd )
    {
        localStorage.setItem( 'youtine', JSON.stringify( updatedSd ) );
    }

    loadStorageData()
    {
        let sd = localStorage.getItem( 'youtine' );
        if ( sd && sd.length )
        {
            try
            {
                sd = JSON.parse( sd );
            }
            catch( e )
            {
                sd = {};
            }
        }
        return { ...Storage.DEFAULT_DATA, ...sd };
    }
}
